<template><Recommendations /></template>
<script>
import Recommendations from "@/components/Dashboard/FCO/Recommendations/Recommendations.vue";
export default {
  name: "recommendations",
  components: { Recommendations },
};
</script>
